module.exports = __webpack_public_path__ + "static/2019-layer-3-93241b4553b6bef23766c64c32b09c6c.png";